// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
// Các imports cần thiết
import "perfect-scrollbar/css/perfect-scrollbar.css";
// CSS layout đã được hợp nhất vào App.css
// Components
import Sidebar from "../components/Sidebar/Sidebar";
import BottomNavigation from "../components/BottomNavigation/BottomNavigation";
import ProtectedRoute from "../components/ProtectedRoute";
import MobileHeader from "../components/MobileHeader/MobileHeader";
// Services
import AuthService from "../services/authService";
// Routes
import routes from "../routes";

// eslint-disable-next-line
const PerfectScrollbar = require('perfect-scrollbar').default;

let ps: any = null;

const Staff: React.FC = () => {
  const [backgroundColor] = useState<string>("white");
  const [activeColor] = useState<string>("info");
  const mainPanel = useRef<HTMLDivElement>(null);
  const location = useLocation();
  
  // Lọc các routes dựa trên quyền của staff
  const filteredRoutes = routes.filter(route => {
    if (route.layout !== "/staff") return false;
    
    // Nếu route yêu cầu quyền truy cập tài nguyên và người dùng không có quyền
    if (route.resourceType && !AuthService.hasPermission(route.resourceType)) {
      return false;
    }
    
    return true;
  });

  useEffect(() => {
    try {
      if (navigator.platform.indexOf("Win") > -1 && mainPanel.current) {
        ps = new PerfectScrollbar(mainPanel.current);
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    } catch (error) {
      console.error("Error initializing perfect-scrollbar:", error);
    }
    
    return function cleanup() {
      try {
        if (navigator.platform.indexOf("Win") > -1 && ps) {
          ps.destroy();
          document.body.classList.toggle("perfect-scrollbar-on");
        }
      } catch (error) {
        console.error("Error destroying perfect-scrollbar:", error);
      }
    };
  }, []);

  useEffect(() => {
    if (mainPanel.current) {
      mainPanel.current.scrollTop = 0;
    }
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [location]);

  return (
    <div className="wrapper">
      <Sidebar
        routes={filteredRoutes}
        bgColor={backgroundColor}
        activeColor={activeColor}
      />
      <div className="main-panel" ref={mainPanel}>
        <MobileHeader />
        <div className="content-wrapper">
          <Routes>
            {routes.map((prop, key) => {
              if (prop.layout === "/staff") {
                return (
                  <Route
                    path={prop.path}
                    key={key}
                    element={
                      <ProtectedRoute 
                        requiredRole="staff"
                        resourceType={prop.resourceType}
                      >
                        {prop.component}
                      </ProtectedRoute>
                    }
                  />
                );
              }
              return null;
            })}
            <Route path="*" element={<Navigate to="/staff/orders" replace />} />
          </Routes>
        </div>
      </div>
      <BottomNavigation routes={filteredRoutes} />
    </div>
  );
};

export default Staff; 